export type FoxONEProfile = {
  avatar: string;
  created_at: number;
  email: string;
  fullname: string;
  id: number;
  is_password_set: boolean;
  is_pin_set: boolean;
  language: string;
  migrate_required: boolean;
  phone_code: string;
  phone_number: string;
  push_id: string;
  referral_code: string;
  reset_pin_required: boolean;
  wallet_id: string;
};

export type MixinProfile = {
  user_id: string;
  identity_number: string;
  full_name: string;
  avatar_url: string;
  created_at: string;
};

export type Profile = {
  id: string;
  phone_code: string;
  phone_number: string;
  email: string;
  user_name: string;
  avatar_url: string;
  description: string;
  remark: string;
  is_mixin_bind: boolean;
  is_phone_bind: boolean;
  status: string;
  created_at: string;
  updated_at: string;
  foxone_migrate_required: boolean;
  mixin?: MixinProfile;
  foxone?: FoxONEProfile;
};

export type Config = {
  c2c: boolean;
};

export type KYCProfile = {
  certified_at: number;
  id_digest: string;
  kyc_error: string;
  kyc_error_message: string;
  kyc_level: number;
  kyc_status: KYCStatus;
  name: string;
  user_id: string;
};

export enum KYCStatus {
  APPROVED = "approved",
  REJECTED = "rejected",
  PROCESSING = "processing",
  UNKONWN = "unkonwn"
}
